import { Delete, Search } from "@mui/icons-material";
import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { debounce, get } from "lodash";
import Autocomplete from "../../../common/js/components/Autocomplete";
import searchConstants from "../search/constants";

const StyledDeleteIcon = styled(Delete)(() => ({
    marginBottom: "0.6vh",
    fill: "#9e9e9e",
}));

const debounceHandleSearchProxy = debounce((onSearch, term) => {
    onSearch(term);
}, searchConstants["DEBOUNCE_SEARCH_DELAY"]);

const Proxy = (props) => {
    const {
        disableInputs,
        element,
        elementIndex,
        errors,
        handleUpdateArrayElement,
        onDelete,
        onSearch,
        searchResults,
    } = props;

    const handleUserProxySelection = (p, b, index) => {
        handleUpdateArrayElement("userAccount.allowedProxies", index, "proxyFor", p.username);
        handleUpdateArrayElement("userAccount.allowedProxies", index, "name", p.firstName + " " + p.lastName);
    };

    return (
        <div>
            <div id={`userProxyContainer${elementIndex}`} style={{ display: "flex", alignItems: "center" }}>
                <div style={{ flex: "11 11 0" }}>
                    <Autocomplete
                        id="proxyFor"
                        label={"Proxy For"}
                        error={get(errors, `proxyFor.${elementIndex}.proxyFor`, null)}
                        initialInputValue={
                            get(element, `proxyFor`, null) != null
                                ? `${get(element, `name`, "")} (${get(element, `proxyFor`, "")})`
                                : ""
                        }
                        itemToString={(i) => get(i, "firstName", null)}
                        onSelect={(p, b) => handleUserProxySelection(p, b, elementIndex)}
                        placeholder="Enter proxy"
                        searchFunction={(searchInput) => debounceHandleSearchProxy(onSearch, searchInput)}
                        startAdornment={elementIndex !== 0 && <Search />}
                        suggestions={searchResults}
                        disabled={false}
                        options={{
                            key: "username",
                            display: (suggestion) => {
                                return (
                                    get(suggestion, "firstName", "") +
                                    " " +
                                    get(suggestion, "lastName", "") +
                                    " (" +
                                    get(suggestion, "username") +
                                    ")"
                                );
                            },
                        }}
                    />
                </div>
                <div style={{ flex: "1 1 0" }}>
                    {disableInputs !== true && (
                        <Button onClick={() => onDelete(elementIndex)}>
                            <StyledDeleteIcon />
                        </Button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Proxy;
